<template>
  <div
    class="grid grid-cols-1 lg:grid-cols-2 lg:gap-12 md:gap-8 sm:gap-5 gap-2 animate-pulse"
  >
    <div class="aspect-4/5 bg-gray-200"></div>

    <div class="sm-p-0 p-2.5">
      <div class="space-y-3.5">
        <div class="h-4.5 bg-gray-200 w-3/4"></div>
        <div class="h-3 bg-gray-200 w-1/2"></div>

        <div class="flex items-center space-x-1.5">
          <div
            class="sm:w-11 sm:h-11 h-10 w-10 rounded-3/4 rounded-full object-cover border border-gray-200 bg-gray-200"
          ></div>
          <div class="space-y-2">
            <div class="h-1 w-12 bg-gray-200"></div>
            <div class="h-1.5 w-24 bg-gray-200"></div>
          </div>
        </div>

        <div class="space-y-3.5 md:space-y-5">
          <div class="">
            <div class="h-3 w-24 bg-gray-200 animate-pulse"></div>
            <div class="mt-2 flex flex-wrap gap-2.5">
              <div class="h-4 w-20 bg-gray-200" v-for="item in 3"></div>
            </div>
          </div>

          <div class="">
            <div class="h-3 w-24 bg-gray-200 animate-pulse"></div>
            <div class="mt-2 flex flex-wrap gap-2.5">
              <div class="h-4 w-20 bg-gray-200" v-for="item in 4"></div>
            </div>
          </div>

          <div class="">
            <div class="h-3 w-24 bg-gray-200 animate-pulse"></div>
            <div class="mt-2 flex flex-wrap gap-2.5">
              <div class="h-4 w-20 bg-gray-200" v-for="item in 2"></div>
            </div>
          </div>

          <div class="h-3 bg-gray-200 w-3/4"></div>
          <div class="h-3 bg-gray-200 w-3/4"></div>
          <div class="lg:col-span-3 h-48 bg-gray-200 md:w-3/4 w-full"></div>
          <div class="mt-2 flex flex-wrap gap-2.5">
            <div class="h-3 w-15 bg-gray-200" v-for="item in 4"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
